import posts from "../blogs/posts.json";
import "../types";
import dayjs from "dayjs";

const ALL_POST = posts.flat();

export function formatDate (dateString) {
  return dayjs(dateString).format("D MMM, YYYY");
}

/**
 * Get all blog posts with a specific tag
 * @param tag {string}
 * @returns {BlogPost[]}
 */
export function getAllBlogPostsByTag (tag) {
  return ALL_POST.filter(post => {
    return post.tags ? post.tags.includes(tag) : false;
  });
}

/**
 * Get two random posts from the blog posts
 * @param {string} [slug] - The slug of the post to exclude from the results
 * @example
 * getTwoRandomPosts() // [ { title: 'Post 1', slug: 'post-1' }, { title: 'Post 2', slug: 'post-2' }
 * @returns {BlogPost[]}
 */
export function getTwoRandomPosts (slug) {
  if (!slug) {
    return ALL_POST.sort(() => 0.5 - Math.random()).slice(0, 2);
  }
  return ALL_POST.filter(post => {
    return post.slug ? post.slug !== slug : false;
  }).sort(() => 0.5 - Math.random()).slice(0, 2);
}

/**
 * Get related posts by tags
 * @param post {BlogPost}
 * @returns {BlogPost[]}
 */
export function getRelatedPostsBySlug (post) {
  ALL_POST.filter(({ tags, slug }) => {
    return tags.some(tag => slug !== post.slug && post.tags.includes(tag));
  }).slice(0, 2);
}

/**
 * Log a Google Analytics event
 * @param url
 */
export function logGoogleAnalyticsPageViewEvent (url = window.location.pathname) {
  if (typeof window.gtag !== "undefined") {
    window.gtag("event", "page_view", {
      page_path: url,
      page_title: document.title
    });
  }
}

export function logGoogleAnalyticsClickOutEvent (url = window.location.pathname) {
  if (typeof window.gtag !== "undefined") {
    window.gtag("event", "click", {
      event_category: "outbound",
      event_label: url,
      transport_type: "beacon"
    });
  }
}

export function logGoogleAnalyticsClickEvent (data) {
  if (typeof window.gtag !== "undefined") {
    window.gtag("event", "click", {
      event_category: data.category || "click",
      event_label: data.label || "",
      value: data.value || 1,
      transport_type: "beacon"
    });
  }
}
